/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarksOptionsDto } from '../../models/survey-marks-options-dto';

export interface GetSurveyMarksFormOptions$Params {}

export function getSurveyMarksFormOptions(
  http: HttpClient,
  rootUrl: string,
  params?: GetSurveyMarksFormOptions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksOptionsDto>> {
  const rb = new RequestBuilder(rootUrl, getSurveyMarksFormOptions.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksOptionsDto>;
      }),
    );
}

getSurveyMarksFormOptions.PATH = '/surveyMarks/options';
